/**
 * Enum loại chi đầu tư
 */
export default {
  /**
   * Nguồn đầu tư
   */
  InvestCapital: 1,
  /**
   * Nhiệm vụ chi đầu tư
   */
  InvestMission: 2,
};
